import { NavLink } from "react-router-dom";
import {
  BagCheck,
  PersonCircle,
  GeoAlt,
  ShieldLock,
  Gear,
  Bell,
  LifePreserver,
  Shop,
  X,
} from "react-bootstrap-icons";

const menu = [
  { path: "orders", label: "Orders", icon: <BagCheck /> },
  { path: "profile", label: "Profile", icon: <PersonCircle /> },
  { path: "addresses", label: "Addresses", icon: <GeoAlt /> },
  { path: "security", label: "Security", icon: <ShieldLock /> },
  { path: "settings", label: "Settings", icon: <Gear /> },
  { path: "notifications", label: "Notifications", icon: <Bell /> },
  { path: "support", label: "Support", icon: <LifePreserver /> },
  { path: "seller-request", label: "Become a Seller", icon: <Shop /> },
];

export default function BuyerSidebar({ onNavigate }) {
  return (
    <aside className="buyer-sidebar">
      {/* Header */}
      <div className="p-3 border-bottom d-flex justify-content-between align-items-center">
        <h6 className="fw-bold mb-0">Buyer Dashboard</h6>
        <button
          className="btn btn-sm btn-light d-lg-none d-flex align-items-center gap-1"
          onClick={onNavigate}
          aria-label="Close sidebar"
        >
          <X /> Close
        </button>
      </div>

      {/* Menu */}
      <ul className="list-group list-group-flush">
        {menu.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            onClick={onNavigate}
            className={({ isActive }) =>
              `list-group-item list-group-item-action border-0 px-4 py-3 d-flex align-items-center gap-2 ${
                isActive ? "active fw-semibold" : ""
              }`
            }
          >
            {item.icon}
            <span>{item.label}</span>
          </NavLink>
        ))}
      </ul>
    </aside>
  );
}
